import React from "react";
import { ManageFeeContainer } from "../../../containers";

const ManageFeeHomePage = (props) => {
  return <ManageFeeContainer />;
};

export default ManageFeeHomePage;
